import invoke from '../../utils/invoke';
import { encrypt } from '../../utils/utils';

const BASE_PATH = process.env.REACT_APP_AUTH_SERVICE || 'https://api.nftcity.com.au/nft-city/api/v1';
//const BASE_PATH = 'http://localhost:2001';
export const signup = (data) => {
    data = encrypt(data);
    return invoke({
        method: 'POST',
        baseURL: BASE_PATH,
        route: 'auth-service/register',
        data: data
    });
}


export const generateCaptcha = (data) => {
    data = encrypt(data);
    return invoke({
        method: 'GET',
        baseURL: BASE_PATH,
        route: 'v1/auth/captcha',
        data: data
    });
}


export const login = (data) => {
    data = encrypt(data);
    return invoke({
        method: 'POST',
        baseURL: BASE_PATH,
        route: 'auth-service/login',
        data: data
    });
}

export const forgetPasswordValidationApi = (data) => {
    data = encrypt(data);
    return invoke({
        method: 'POST',
        baseURL: BASE_PATH,
        route: 'auth-service/send-otp-token',
        data: data
    });
}

export const forgetUsernameValidationApi = (data) => {
    data = encrypt(data);
    return invoke({
        method: 'POST',
        baseURL: BASE_PATH,
        route: 'auth-service/forgot-username',
        data: data
    });
}


export const updatePassword = (data) => {
    data = encrypt(data);
    return invoke({
        method: 'POST',
        baseURL: BASE_PATH,
        route: 'auth-service/update-credential',
        data: data
    });
}

export const verifyOtpApi = (data) => {
    data = encrypt(data);
    return invoke({
        method: 'POST',
        baseURL: BASE_PATH,
        route: 'auth-service/verify-otp',
        data: data
    });
}



export const sendOtpApi = (data) => {
    data = encrypt(data);
    return invoke({
        method: 'POST',
        baseURL: BASE_PATH,
        route: 'auth-service/send-otp-token',
        data: data
    });
}




